// extracted by mini-css-extract-plugin
module.exports = {"showMore":"SocialMediaWallItem_showMore__yqXLw","waveBottom":"SocialMediaWallItem_waveBottom__yK0Qz"};